<template>
    <div>
        <div v-if="days.length === 0">
            Loading...
        </div>
        <table v-if="days.length > 0" class="table table-striped table-bordered">
            <thead>
                <tr>
                    <td>Name</td>
                    <td>Email</td>
                    <td>Phone</td>
                    <td>Website</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="day in days" :key="day.date">
                    <td>{{day.date}}</td>
                    <td>{{day.temperatureC}}</td>
                    <td>{{day.temperatureF}}</td>
                    <td>{{day.summary}}</td>
                </tr>
            </tbody>
        </table>

    </div>
</template>
<script>
    import axios from 'axios';

    export default {
        data: function () {
            return {
                days: [],
            };
        },
        methods: {
            async fetchWeather() {
                const { data } = await axios.get('/api/weatherforecast');
                this.days = data;
            }
        },
        async mounted() {
            await this.fetchWeather();
        }
    }
</script>